import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { MdInfo } from "react-icons/md";


const SFInfoIcon = ({helpText}) => {
    return (
        <Tooltip
        title={
            <Typography fontSize={12} color='#fff' sx={{ whiteSpace: 'pre-wrap' }}>
                {helpText}
            </Typography>
        } placement="top" arrow>
            <div className='mx-1 cursor-pointer'>
                <MdInfo color='gray' fontSize={18} />
            </div>
        </Tooltip>
    );
}

export default SFInfoIcon;
